module.exports = __webpack_public_path__ + "img/xml.fe5c0f69.png";